import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = ({ onAction }) => {
  const { t } = useLanguage();

  const actions = [
    {
      key: 'processPayment',
      label: t('financial.processPayment'),
      icon: 'CreditCard',
      variant: 'default'
    },
    {
      key: 'generateInvoice',
      label: t('financial.generateInvoice'),
      icon: 'FileText',
      variant: 'outline'
    },
    {
      key: 'processRefund',
      label: t('financial.processRefund'),
      icon: 'ArrowLeftRight',
      variant: 'outline'
    },
    {
      key: 'exportAccounting',
      label: t('financial.exportAccounting'),
      icon: 'Download',
      variant: 'outline'
    },
    {
      key: 'generateContract',
      label: t('financial.generateContract'),
      icon: 'FileSignature',
      variant: 'outline'
    },
    {
      key: 'viewReports',
      label: t('financial.viewReports'),
      icon: 'BarChart3',
      variant: 'outline'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        {t('financial.quickActions')}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.key}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            fullWidth
            onClick={() => onAction(action?.key)}
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;